import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues } from '../tournamentFormDialog/form';
import { TournamentFormDialog } from '../tournamentFormDialog/TournamentFormDialog';

import { tournamentsService } from 'v2/api/tournamentsService';
import { TournamentForm } from 'v2/types/TournamentModel';
import { handleHttpError } from 'v2/utils';

interface CreateTournamentButtonProps {
  onSuccess: VoidFunction;
}

export const CreateTournamentButton: FC<CreateTournamentButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createTournament', tournamentsService.createTournament, {
    onSuccess: () => {
      onSuccess();
      toast.success('Tournament has been created successfully');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: TournamentForm, resetForm: VoidFunction) => {
    trigger(values).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Tournament
      </Button>

      <TournamentFormDialog
        title="Create Tournament"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
